import { PlusOutlineIcon } from '@carboncopyco/icons';
import { Button, TextCaption } from '@carboncopyco/ui';
import classNames from 'classnames';
import { useCallback } from 'react';
import type { CustomChartIconProps } from './CustomChartIcon';
import { CustomChartIcon } from './CustomChartIcon';
import type { ICustomTemplateChart } from './types';

export interface TemplatesListProps {
  isLoadingTemplates: boolean;
  templates: ICustomTemplateChart[];
  selectedTemplate: string | undefined | null;
  onTemplateClick: (value: Record<string, any>) => void;
  onAddNewTemplateClick: () => void;
}

export const TemplatesList = ({
  templates,
  selectedTemplate,
  onTemplateClick,
  onAddNewTemplateClick,
  isLoadingTemplates,
}: TemplatesListProps) => {
  const getContent = useCallback(() => {
    if (isLoadingTemplates) {
      return <div className="w-full h-full">Loading... </div>;
    }

    if (!templates.length) {
      return <div className="w-full h-full">No templates</div>;
    }

    return (
      <ul className="w-full absolute">
        {templates.map(
          (
            { id, templateName, isActive, template, templateIcon, ...rest },
            idx
          ) => {
            return (
              <li
                onClick={() => {
                  onTemplateClick({
                    ...rest,
                    isActive,
                    id,
                    templateName,
                    templateIcon,
                    template: JSON.parse(template),
                  });
                }}
                key={id + idx}
                className={classNames(
                  'py-3.5 pl-1.5 pr-1.5 rounded-md hover:bg-ds-natural-50 active:bg-ds-natural-50 cursor-pointer',
                  selectedTemplate === id && 'bg-ds-natural-50'
                )}
              >
                <div className="flex items-center">
                  <div className="h-full w-7">
                    <CustomChartIcon
                      name={templateIcon as CustomChartIconProps['name']}
                    />
                  </div>

                  <div className="ml-2 h-full flex items-center w-3/4 max-w-3/4">
                    <TextCaption
                      label={templateName}
                      color={
                        selectedTemplate === id
                          ? 'text-ds-natural-600'
                          : 'text-ds-natural-300'
                      }
                      ellipsis
                    />
                  </div>
                </div>
              </li>
            );
          }
        )}
      </ul>
    );
  }, [templates, selectedTemplate, isLoadingTemplates]);

  return (
    <div className="w-full pb-3 flex flex-col h-full">
      <div className="w-full ">
        <Button
          label="New Template"
          leftIcon={<PlusOutlineIcon />}
          onClick={() => {
            onAddNewTemplateClick();
          }}
        />
      </div>
      <div className="overflow-y-auto overflow-x-hidden w-full flex flex-1 relative pt-5">
        {getContent()}
      </div>
    </div>
  );
};
